import { useRouter } from "next/router";
import toast from "react-hot-toast";

import { BusinessEventEnum } from "@/consts/AnalyticsEvent";
import { useUserContext } from "@/features/auth/contexts/useUserContext";
import { Button } from "@/features/common/components/Button";
import { useAnalytics } from "@/features/common/hooks/useAnalytics";
import { UserRoleEnum } from "@/generated/graphql-hooks";
import UnlockIcon from "@/icons/editAlbum/unlock.svg";

export const PrivateAlbumButtonOverlay = ({
  modelId,
  canAccessPrivate,
}: {
  modelId: string;
  canAccessPrivate?: boolean;
}) => {
  const { trackEvent } = useAnalytics();
  const { push } = useRouter();
  const { user } = useUserContext();

  const onAccessPrivateAlbum = () => {
    if (!canAccessPrivate) {
      return toast.error("你沒有權限查看此用戶的隱藏相簿");
    }
    push(`/kol/privateAlbum/${modelId}`);
    if (user?.role === UserRoleEnum.Business) {
      trackEvent(BusinessEventEnum.CLICK_MODEL_PRIVATE_ALBUM, { modelId });
    }
  };

  return (
    <Button
      className="bg-primary absolute inset-0 z-40 flex flex-col items-center justify-center space-y-1 rounded-lg opacity-90"
      onClick={onAccessPrivateAlbum}
    >
      {!canAccessPrivate && <UnlockIcon />}
      <div className="text-lg text-white sm:text-xl">查看隱藏相簿</div>
    </Button>
  );
};
